<template>
    <v-card class="rounded-lg">
        <v-card-text>
            <v-row class="mt-0">
                <span class="c-search-field">
                    <v-text-field class="ml-2 my-1"
                                  ref="searchField"
                                  type="text"
                                  outlined
                                  dense
                                  hide-details
                                  clearable
                                  :rules="inputRules"
                                  maxlength="200"
                                  v-model="searchValue"
                                  prepend-inner-icon="mdi-magnify"
                                  :label="$t('quickSearch.searchLabel')"
                                  :aria-label="$t('quickSearch.searchLabel')"
                                  @click:clear="onClearSearch">

                    </v-text-field>
                </span>
            </v-row>
            <v-row align="center" class="mx-0">
                <span class="font-weight-bold text-normal">{{formatMenuText($t('quickSearch.operation'))}}: </span>
                <v-radio-group class="mt-0" v-model="searchMethod" row dense hide-details @change="updateSearchPreference=true;">
                    <v-radio class="mx-2" :label="formatMenuText($t('quickSearch.equal'))" value="0"></v-radio>
                    <v-radio class="mx-2" :label="formatMenuText($t('quickSearch.startWith'))" value="1"></v-radio>
                    <v-radio class="mx-2" :label="formatMenuText($t('quickSearch.endWith'))" value="2"></v-radio>
                    <v-radio class="mx-2" :label="formatMenuText($t('quickSearch.contains'))" value="3"></v-radio>
                </v-radio-group>
            </v-row>
            <v-row align="center" class="mx-0 mb-2">
                <span class="font-weight-bold text-normal">{{formatMenuText($t('quickSearch.fields'))}}: </span>
                <v-checkbox v-for="column in displayColumns"
                            :key="column.value"
                            class="mx-2 my-0"
                            dense hide-details
                            v-model="searchColumns"
                            :label="column.text"
                            :value="column.value"
                            @change="onCkeckedField"></v-checkbox>
            </v-row>
            <v-row align="center" justify="end" class="ma-2">
                <v-hover v-slot="{hover}">
                    <v-btn class="text-none"
                            :color="hover ? 'buttonHover' : 'primary'"
                            depressed
                           :disabled="applyBtnDisabled"
                           @click="onApply">
                        {{formatMenuText($t('apply'))}}
                    </v-btn>
                </v-hover>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "quickSearch",
        props: {
            displayColumns: {
                type: Array
            },
            user: {
                type: Object
            },
            reportCode: {
                type: String
            }
        },
        data() {
            return {
                searchValue: "",
                searchColumns:[],
                searchMethod: "0",
                updateSearchPreference: false
            }
        },
        mounted() {
            if (this.user.searchPreference) {
                let searchPreferences = JSON.parse(this.user.searchPreference)
                if (searchPreferences) {
                    let userSearchPreference = searchPreferences.find(x => x.IndexDefinitionCode == this.reportCode);
                    if (userSearchPreference) {
                        this.searchColumns = userSearchPreference.SearchColumns;
                        this.searchMethod = userSearchPreference.SearchMethod.toString();
                    }
                }
            }
            
        },
        computed: {
            inputRules() {
                return [
                    (val) => (!val || val.length <= 200) || this.$t('search-max-200')
                ]
            },
            applyBtnDisabled() {
                return (this.searchColumns == null) || (this.searchColumns.length < 1) || (this.searchMethod == null);
            },
            searchParams() {
                return {
                    searchValue: this.searchValue,
                    searchMethod: this.searchMethod,
                    searchColumns: this.searchColumns,
                    updateSearchPreference: this.updateSearchPreference
                };
            }
        },
        methods: {
            formatMenuText(text) {
                if (!text) return text;

                // Check the titleCase setting from the current experience
                const titleCase = this.$experience.titleCase !== false; // default to true if not set

                if (titleCase) {
                    // Title case: capitalize first letter of all words
                    return text.split(' ').map(word => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                } else {
                    // Sentence case: only capitalize first letter of first word
                    // But preserve acronyms
                    const words = text.split(' ');
                    return words.map((word, index) => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        if (index === 0) {
                            // First word: capitalize first letter
                            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                        } else {
                            // Other words: all lowercase
                            return word.toLowerCase();
                        }
                    }).join(' ');
                }
            },
            onClearSearch() {
                this.searchValue = "";
                this.$emit("search", this.searchParams);
                this.updateSearchPreference = false;
            },
            onApply() {
                this.$emit("search", this.searchParams);
                this.updateSearchPreference = false;
            },
            onCkeckedField() {
                if ((this.searchColumns != null) && (this.searchColumns.length > 3)) {
                    this.searchColumns.pop();
                } else
                    this.updateSearchPreference = true;
            }
        }
    }
</script>

<style scoped>
    .c-search-field {
        width: 75% !important;
    }
    /* for mobile */
    @media (max-width: 960px) {
        .c-search-field {
            width: 100% !important;
        }
    }
</style>